var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TelaLoading',{staticClass:"loading-pdf",attrs:{"overlay":_vm.loading}}),_c('iframe',{ref:"iframePdf",attrs:{"src":_vm.path,"name":"pdfjsview"},on:{"load":_vm.carregarDocumento}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }